import React from 'react';
export function VisionSection() {
  return <section className="py-24 bg-gradient-to-b from-rose-50 to-white relative overflow-hidden" data-id="element-378">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-379">
        <div className="absolute right-0 top-0 w-96 h-96 bg-rose-300 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-380"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-orange-300 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-381"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl text-center" data-id="element-382">
        <div className="inline-block bg-white px-4 py-1.5 rounded-full text-rose-500 font-medium text-sm mb-8 shadow-sm border border-rose-100" data-id="element-383">
          🔮 Imaginá esto...
        </div>

        <div className="space-y-6 text-xl md:text-3xl font-serif text-gray-800 leading-relaxed italic" data-id="element-384">
          <p className="animate-fade-in" style={{
          animationDelay: '0.1s'
        }} data-id="element-385">
            Son las 8 pm. No estás colapsada.
          </p>
          <p className="animate-fade-in text-gray-900 font-medium" style={{
          animationDelay: '0.3s'
        }} data-id="element-386">
            Sabés qué hacer.
          </p>
          <p className="animate-fade-in" style={{
          animationDelay: '0.5s'
        }} data-id="element-387">
            Tu comida se cocina sola.
          </p>
          <p className="animate-fade-in" style={{
          animationDelay: '0.7s'
        }} data-id="element-388">
            Tu casa huele a algo rico.
          </p>
          <p className="animate-fade-in text-rose-600 font-medium" style={{
          animationDelay: '0.9s'
        }} data-id="element-389">
            Y vos… te servís primero.
          </p>
        </div>

        <div className="mt-12 pt-12 border-t border-rose-100 max-w-2xl mx-auto" data-id="element-390">
          <p className="text-lg text-gray-600 font-medium" data-id="element-391">
            Porque cuando tu cocina no pesa, <br data-id="element-392" />
            <span className="text-gray-900 font-bold text-xl" data-id="element-393">
              tu vida se siente más liviana.
            </span>
          </p>
        </div>
      </div>
    </section>;
}